module.exports = __webpack_public_path__ + "img/06zhengfu.d8bc0a9e.png";